import { type FC } from "react";

import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import { TableCell } from "./TableCell.js";

/**
 * Used in Sample type administration editing grid.
 * Provides a column showing the edit icon
 */
const ActionCell: FC<IAgGridCellProps> = (props) => {
  const configureProps: any = props.data.configure;

  return (
    <TableCell
      triggerButtonProps={{
        label: configureProps.tooltip,
        icon: "edit",
        onPress: () => configureProps.onClick?.(props.data),
        isDisabled: configureProps.disabled,
      }}
    />
  );
};

export default ActionCell;
